<template>
  <div>
    <div class="app-content--inner p-0">
      <page-title
        heading="Ubah Obat"
        class="custom-breadcrumb"
        :breadcrumb="[
          {
            label: 'Manajemen Obat & BHP',
            link: '/klinik/obat'
          },
          {
            label: 'Ubah Obat & BHP',
            active: true
          }
        ]"
      />
      <div class="container-fluid __zoom_out_obat" v-if="status" style="zoom:80%">
        <div class="row">
          <div class="col-md-12">
            <div class="card card-box mb-5">
              <div class="card-body p-5">
                <b-form @submit.prevent="submitinputObat">
                  <b-row class="outer-obat-tambah">
                    <b-col sm="6">
                      <!-- kode obat -->
                      <b-form inline>
                        <label
                          class="col-md-3"
                          style="font-size: 13px;padding:5px;"
                          >Kode Obat <span style="color:red">*</span></label
                        >
                        <b-form-input
                          maxlength="10"
                          class="col-md-6 pl-2"
                          style="padding-right : 30px"
                          @input="inputKode($event)"
                          v-model="dataObat.kode_layanan"
                        ></b-form-input>
                        <b-form-invalid-feedback class="ml-1">
                          {{ errorData[0].desc }}
                        </b-form-invalid-feedback>
                      </b-form>
                      <!-- nama obat -->
                      <b-form inline>
                        <label
                          class="col-md-3"
                          style="font-size: 13px;padding:5px;"
                          >Nama Obat <span style="color:red">*</span></label
                        >
                        <b-form-input
                          maxlength="100"
                          @input="inputNama($event)"
                          class="col-md-6 pl-2"
                          v-model="dataObat.nama_layanan"
                        ></b-form-input>
                        <b-form-invalid-feedback class="ml-1">
                          {{ errorData[1].desc }}
                        </b-form-invalid-feedback>
                      </b-form>
                      <!-- kategori -->
                        <b-form inline>
                          <label
                            class="col-md-3"
                            style="font-size: 13px;padding:5px;"
                            >Kategori
                            <span style="color:red" class="mr-2">*</span>
                            <font-awesome-icon
                              v-tooltip="{
                                content: `<span>Anda dapat memilih 'Lainnya' jika belum mengetahui Kategori obat </span><br/>`
                              }"
                              class=" tooltip-obat"
                              icon="info-circle"
                            />
                          </label>
                          <vue-select
                            style="font-size:13px"
                            :options="optKategori"
                            @input="inputKategori($event)"
                            v-model="selectedKategori"
                            class="form-select-tarif col-md-6 p-0"
                            placeholder="Pilih Kategori"
                          />
                          <b-form-invalid-feedback class="ml-1">
                            {{ errorData[2].desc }}
                          </b-form-invalid-feedback>
                        </b-form>
                      <!-- jenis -->
                      <b-form inline>
                        <label
                          class="col-md-3"
                          style="font-size: 13px;padding:5px;"
                          >Jenis
                          <span style="color:red" class="mr-2">*</span>
                          <font-awesome-icon
                            v-tooltip="{
                              content: `<span>Anda dapat memilih 'Lainnya' jika belum mengetahui jenis obat </span><br/>`
                            }"
                            class=" tooltip-obat"
                            icon="info-circle"
                            style="margin-left:20px"
                          />
                        </label>
                        <vue-select
                          style="font-size:13px"
                          :options="optJenis"
                          @input="inputJenis($event)"
                          v-model="selectedJenis"
                          class="form-select-tarif col-md-6 p-0"
                          placeholder="Pilih Jenis"
                        />
                        <b-form-invalid-feedback class="ml-1">
                          {{ errorData[3].desc }}
                        </b-form-invalid-feedback>
                      </b-form>
                    </b-col>
                    <b-col sm="6">
                      <!-- harga -->
                      <b-form inline>
                        <label
                          class="col-md-3"
                          style="font-size: 13px;padding:5px;"
                          >Harga <span style="color:red">*</span></label
                        >
                        <b-form-input
                          v-model.lazy="dataObat.tarif"
                          maxlength="19"
                          v-money="money"
                          class="col-md-6"
                        >
                        </b-form-input>
                        <b-form-invalid-feedback class="ml-1">
                        </b-form-invalid-feedback>
                      </b-form>
                      <!-- stok -->
                      <b-form inline>
                        <label
                          class="col-md-3"
                          style="font-size: 13px;padding:5px;"
                          >Stok</label
                        >
                        <b-form-input
                          v-model="dataObat.stok"
                          style="padding-right : 30px"
                          v-on:keypress="NumbersOnly"
                          maxlength="100"
                          class="col-md-6 pl-2"
                          placeholder="input stok"
                          :disabled="!stockIsEdit"
                        ></b-form-input>
                        <span v-if="!stockIsEdit" @click="enableEdit()" style="padding-left: 10px; cursor: pointer;">
                            <font-awesome-icon icon="pencil-alt" />
                        </span>
                        <b-form-invalid-feedback class="ml-1">
                        </b-form-invalid-feedback>
                      </b-form>
                      <!-- satuan -->
                      <b-form inline>
                        <label
                          class="col-md-3"
                          style="font-size: 13px;padding:5px;"
                          >Satuan
                        </label>
                        <vue-select
                          style="font-size:13px"
                          :options="optSatuan"
                          v-model="selectedSatuan"
                          class="form-select-tarif col-md-7 p-0"
                          placeholder="pilih satuan"
                          :disabled="!stockIsEdit"
                        />
                        <b-form-invalid-feedback class="ml-1">
                        </b-form-invalid-feedback>
                      </b-form>
                      <!-- catatan -->
                      <b-form inline  style="align-items: baseline">
                        <label
                          class="col-md-3"
                          style="font-size: 13px;padding:5px;"
                          >Catatan</label
                        >
                          <b-form-textarea
                            :disabled="!stockIsEdit"
                            class="col-md-8"
                            rows="4" no-resize
                            v-model="dataObat.note"
                            placeholder="input catatan pendukung.
Contoh: Masa berlaku obat
20 September 2025, pembelian batch 1."
                          ></b-form-textarea>
                      </b-form>
                    </b-col>
                  </b-row>
                  <b-row class="d-flex align-items-center ">
                    <b-col lg="12 px-0 pt-5">
                      <div align="right">
                        <b-button
                          class="text-capitalize mr-2"
                          variant="danger"
                          :to="{ path: '/klinik/obat' }"
                          >keluar</b-button
                        >
                        <b-button
                          class="text-capitalize"
                          type="submit"
                          variant="primary"
                          >simpan</b-button
                        >
                      </div>
                    </b-col>
                  </b-row>
                </b-form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import startCase from "lodash/startCase";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faPlus,
  faMinus,
  faInfoCircle,
  faPencilAlt
} from "@fortawesome/free-solid-svg-icons";
import { mapGetters } from "vuex";
library.add(faPlus, faMinus, faInfoCircle,faPencilAlt);
import { VMoney } from "v-money";

export default {
  components: {
    "vue-select": () => import("@/components/VueSelect.vue"),
  },
  computed: {
    ...mapGetters(["getKlinikId", "getRolesName"])
  },
  directives: {
    money: VMoney
  },
  data() {
    return {
      status: false,
      dataObat: {
        klinik_id: null,
        kode_layanan: null,
        nama_layanan: null,
        tarif: null,
        kategori_obat_id: null,
        jns_obat_id: null,
        stok: null,
        satuan_id: null,
        note: null,
      },
      money: {
        decimal: "",
        thousands: ",",
        prefix: "Rp. ",
        suffix: "",
        precision: 0
      },
      selectedKategori: [],
      selectedJenis: [],
      selectedSatuan: [],
      selectedKelompok: "B",
      optJenis: [],
      optKategori: [],
      optSatuan: [],
      beingSubmit: false,
      obatId: null,
      errorData: [
        {
          label: "kode_layanan",
          desc: null,
          error: null
        },
        {
          label: "nama_layanan",
          desc: null,
          error: null
        },
        {
          label: "kategori_obat_id",
          desc: null,
          error: null
        },
        {
          label: "jns_obat_id",
          desc: null,
          error: null
        }
      ],
      stockIsEdit: false,
    };
  },
  mounted() {
    this.obatId = this.$router.currentRoute.params.id;
    this.getData(this.obatId);
    this.getKategori();
    this.getJenis();
    this.getSatuan();
  },
  beforeRouteLeave(to, from, next) {
    if (!this.beingSubmit && localStorage.getItem("IDLE") != 1) {
      this.$swal({
        title: startCase("keluar"),
        html: `Apakah Anda yakin untuk keluar dari halaman ini?<br>Data yang telah ditulis tidak akan tersimpan.`,
        type: "warning",
        showCancelButton: true,
        cancelButtonText: startCase("tidak"),
        confirmButtonText: startCase("ya")
      }).then(res => {
        if (res.value) {
          next();
        } else {
          next(false);
        }
      });
    } else {
      next();
    }
  },
  methods: {
    async getData(id) {
      try {
        const res = await this.$axios.get(`klinik/obat/${id}`);
        const { data, success } = res.data;

        if (success) {
          this.$nextTick(() => {
            this.dataObat = {
              klinik_id: this.getKlinikId,
              kode_layanan: data.kode_layanan,
              nama_layanan: data.nama_layanan,
              tarif: data.tarif,
              kategori_obat_id: data.kategori_obat,
              jns_obat_id: data.jenis_obat,
              stok: data.stok == null ? '-': data.stok,
              satuan_id: data.satuan,
              note: data.note,
            };

            this.selectedKategori = {
              label: data.kategori_obat.name,
              value: data.kategori_obat.id
            };

            this.selectedJenis = {
              label: data.jenis_obat.name,
              value: data.jenis_obat.id
            };

            if(data.satuan != null) {
              this.selectedSatuan = {
                label: data.satuan.name,
                value: data.satuan.id
              }
            }

            this.status = true;
          });
          // this.stockIsEdit = res.data.is_edit;
        }
      } catch (error) {}
    },
    async getJenis() {
      try {
        const res = await this.$axios.get(`klinik/obat/jenis`);
        const { data, status } = res.data;
        if (status) {
          this.optJenis = data.map(res => ({
            ...res,
            label: res.name,
            value: res.id
          }));
        }
      } catch (error) {}
    },
    async getSatuan() {
      try {
        const res = await this.$axios.get(`klinik/satuan/list`);
        const { data, status } = res.data;
        if (status) {
          this.optSatuan = data.map(res => ({
            ...res,
            label: res.label,
            value: res.value
          }));
        }
      } catch (error) {}
    },
    async getKategori() {
      try {
        const res = await this.$axios.get(`klinik/obat/kategori`);
        const { data, status } = res.data;
        if (status) {
          this.optKategori = data.map(res => ({
            ...res,
            label: res.name,
            value: res.id
          }));
        }
      } catch (error) {}
    },
    inputNama(val) {
      if (val.length == 0) {
        this.errorData[1].error = true;
        this.errorData[1].desc = "Nama obat harus diisi";
        return;
      } else {
        this.errorData[1].error = null;
        this.errorData[1].desc = null;
      }
    },
    inputKode(val) {
      val = val.toUpperCase();

      if (val.match(/[^a-zA-Z0-9\-]+/) !== null) {
        this.errorData[0].error = true;
        this.errorData[0].desc = "Hanya bisa huruf, angka, dan -";
        return;
      } else if (val.length == 0) {
        this.errorData[0].error = true;
        this.errorData[0].desc = "Kode obat harus diisi";
        return;
      } else if (val.length < 3) {
        this.errorData[0].error = true;
        this.errorData[0].desc = "Kode obat minimal 3 karakter";
        return;
      } else {
        this.errorData[0].error = null;
        this.errorData[0].desc = null;
      }

      if (this._timeoutKodeLayanan) clearTimeout(this._timeoutKodeLayanan);

      this._timeoutKodeLayanan = setTimeout(() => {
        this.$axios
          .post(
            `klinik/obat/cek?kode_layanan=${this.dataObat.kode_layanan}&id_layanan=${this.obatId}&klinik_id=${this.getKlinikId}`
          )
          .then(response => {
            if (response.data.status == false) {
              this.errorData[0].error = true;
              this.errorData[0].desc = "Kode obat tidak boleh sama";
            } else {
              this.errorData[0].error = null;
              this.errorData[0].desc = null;
            }
          })
          .catch(error => {})
          .finally(() => {
            clearTimeout(this._timeoutKodeLayanan);
          });
      }, 600);
    },
    inputJenis(val) {
      if (val.length == 0 || val == null) {
        this.errorData[3].error = true;
        this.errorData[3].desc = "Jenis harus dipilih";
        return;
      } else {
        this.errorData[3].error = null;
        this.errorData[3].desc = null;
      }
    },
    inputKategori(val) {
      if (val.length == 0 || val == null) {
        this.errorData[2].error = true;
        this.errorData[2].desc = "Kategori harus dipilih";
        return;
      } else {
        this.errorData[2].error = null;
        this.errorData[2].desc = null;
      }
    },
    submitinputObat() {
      let statusOk = null;

      //pengecekan apakah ada object data error
      this.errorData.map(data => {
        if (data.error) {
          statusOk = true;
          this.$swal({
            type: "warning",
            text: "Silakan cek kembali pengisian data Anda!"
          });
        }
      });

      if (!statusOk) {
        this.processUpdate();
      }
    },
    async processUpdate() {
      try {
        let sendData = {
          klinik_id: this.getKlinikId,
          kode_layanan: this.dataObat.kode_layanan.toUpperCase(),
          nama_layanan: this.dataObat.nama_layanan,
          tarif: parseInt(this.dataObat.tarif.replace(/\D/g, "")),
          kategori_obat_id: this.selectedKategori.value,
          jns_obat_id: this.selectedJenis.value,
          stok: parseInt(this.dataObat.stok),
          satuan_id: this.selectedSatuan.value,
          note: this.dataObat.note,
        };
        
        const res = await this.$axios.put(
          `klinik/obat/${this.obatId}`,
          sendData
        );

        const { status, message } = res.data;

        if (status == true) {
          this.$swal({
            type: "success",
            text: "Data Obat berhasil disimpan!"
          }).then(res => {
            if (res.value) {
              this.beingSubmit = true;
              this.$router.push({ path: "/klinik/obat" });
            }
          });
        } else {
          this.$swal({
            type: "warning",
            text: message
          });
        }
      } catch (error) {}
    },
    NumbersOnly(evt) {
      evt = (evt) ? evt : window.event;
      let charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) || charCode === 46) {
        evt.preventDefault();;
      } else {
        this.dataObat.stok = this.dataObat.stok.replace(/-/g,'')
        return true;
      }
    },
    enableEdit(){
    this.$swal({
        title: "Ubah Stok",
        html: `Apakah Anda yakin akan mengubah stok? <br/> Perubahan stok akan mempengaruhi pelaporan.`,
        type: "warning",
        showCancelButton: true,
        cancelButtonText: startCase("tidak"),
        confirmButtonText: startCase("ya")
      }).then(res => {
        if (res.value) {
          this.stockIsEdit = true;
        }
      });
  }
  },
};
</script>

<style>
.tooltip {
  display: block !important;
  z-index: 10000;
}

.tooltip .tooltip-inner {
  background: rgb(255, 255, 255);
  color: black;
  border-radius: 5px;
  padding: 5px 10px 4px;
  box-shadow: 0px 0px 0px rgba(black, 0.1) !important;
  border-style: solid;
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: black;
}

.custom-breadcrumb div.row ol.breadcrumb li.breadcrumb-item.active {
  text-transform: capitalize !important;
}
</style>

<style lang="scss" scoped>
.outer-obat-tambah {
  position: relative;
  border-radius: 15px;
  border: 2px solid #bfbfbf;
  outline-color: #bfbfbf;
  padding: 15px;
  outline-width: thin;
}

.form-inline label {
  display: -moz-box;
  display: flex;
  -moz-box-align: center;
  align-items: center;
  -moz-box-pack: center;
  justify-content: flex-start;
  margin-bottom: 0;
}

.invalid-feedback {
  margin-left: 150px !important;
  min-height: 18px;
  display: block;
}
</style>
